<template>
  <v-container
    :class="pageLoaded && ((isCart && (!getCartOrder || getCartOrder.lineItems.length === 0)||!isCart && (orders && orders.length === 0)))?'fill-height' :''"
  >
    <v-container
      v-if="pageLoaded && (isCart && (!getCartOrder || getCartOrder.lineItems.length === 0))"
      class="fill-height"
      style="background-image:url(/volcano.jpg);  background-size: cover;
  background-repeat: no-repeat;"
    >
      <v-row class="justify-center">
        <div class="glass2">Your Cart is empty</div>
      </v-row>
      <v-row class="justify-center">
        <v-btn @click="$router.push({ path: '/releases' })">Goto Catalog</v-btn>
      </v-row>
    </v-container>
    <v-container
      v-if="pageLoaded && (!isCart && (orders && orders.length === 0))"
      class="fill-height"
      style="background-image:url(/volcano.jpg);  background-size: cover;
  background-repeat: no-repeat;"
    >
      <v-row class="justify-center">
        <div
          class="text-center"
        >If you've placed orders in the past, you can access them by authorization with your PayPal account<br>
                <span class="text-center caption">
          If you have any questions, please contact us
          <router-link :to="{name:'contact'}">here</router-link>
        </span></div>
      </v-row>

      <v-row class="justify-center">
        <v-btn color="#ffc439" dark class="ml-3 align-self-center" :href="paypalConnectURL">
          Login with
          <img
            class="ml-2 mr-2"
            style="height:20px"
            src="data:image/svg+xml;base64,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"
            alt="paypal"
          />
        </v-btn>
      </v-row>
    </v-container>
    <!--
    isEmptyObj(order): {{isEmptyObj(cart)}} 
    isEmptyObj(order): {{isEmptyObj(order)}}-->
    <v-row no-gutters class="mb-2" v-if="pageLoaded && (!isEmptyObj(order) || !isEmptyObj(cart))">
      <v-col
        class="glass2 pl-0 d-flex flex-grow-0 flex-shrink-1 align-self-center"
      >{{ isCart ? "Cart" : "Order" }}</v-col>
    </v-row>
    <v-row no-gutters class="mb-2" v-if="isNewPurchase">
      <v-col class="glass4 pl-0">
        <v-banner color="success" dark rounded outlined>{{bannerText}}</v-banner>
      </v-col>
    </v-row>
    <v-row no-gutters class="mb-0 mt-2" v-if="!isCart && getCartOrder">
      <v-col class="caption pl-0">Date: {{ moment(getCartOrder.dateFulfilled).format('LLLL') }}</v-col>
    </v-row>
    <v-row no-gutters class="mb-2" v-if="!isCart && getCartOrder">
      <v-col class="caption pl-0">Reference ID: {{ getCartOrder.id }}</v-col>
    </v-row>

    <div v-if="getCartOrder && getCartOrder.lineItems.length > 0">
      <v-data-iterator
        :items="getCartOrder.lineItems"
        class="pa-0"
        :items-per-page="myTableState.itemsPerPage"
        no-data-text
        :hide-default-footer="getCartOrder.lineItems === undefined || getCartOrder.lineItems.length <= myTableState.itemsPerPage"
      >
        <!-- :to="{name:'release',params:{id:getReleaseByProductId(product.productId).id,releasename:normalizeUrl(getReleaseByProductId(product.productId).name)}}" -->
        <template v-slot:default="props">
          <v-divider class="divider0"></v-divider>
          <v-card
            class="translucent-bg-1 mb-1"
            :style="'transition-delay: ' + ((idx+1)/12) +'s'"
            dense
            v-for="(product, idx) in props.items"
            :key="product.productId"
          >
            <v-row no-gutters class="pa-1">
              <v-col class="flex-grow-0 flex-shrink-1 pa-1 pl-2">
                <v-img
                  :src="getFileUrl(getReleaseByProductId(product.productId))"
                  aspect-ratio="1"
                  min-width="80"
                ></v-img>
              </v-col>
              <v-col class="flex-grow-1 flex-shrink-0 pa-1 pl-2">
                <div class="caption">{{getTrack(product.productId).artists}}</div>
                <div class="glass4">{{getTrack(product.productId).name}}</div>
              </v-col>
              <v-col class="flex-grow-0 flex-shrink-1 text-no-wrap align-self-center caption">
                <v-btn
                  v-if="isCart"
                  icon
                  @click.stop="orderAction({cmd:'REMOVE_FROM_ORDER',productId:product.productId})"
                >
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
                {{formatAmountCurrency(getTrack(product.productId).price,"GBP")}}
              </v-col>
            </v-row>
            <v-divider class="divider0"></v-divider>
          </v-card>
        </template>
      </v-data-iterator>
      <v-divider class="divider0"></v-divider>
      <v-card class="translucent-bg-1 mb-1" dense>
        <v-row no-gutters class="pa-1">
          <v-col
            class="flex-grow-0 flex-shrink-1 pa-1 pl-2 text-no-wrap align-self-center"
          >Total amount</v-col>
          <v-col class="flex-grow-1 flex-shrink-0 pa-1 pl-2 align-self-center">
            <span class="caption">inclusive Tax</span>
          </v-col>
          <v-col
            align="right"
            class="flex-grow-0 flex-shrink-1 text-no-wrap align-self-center"
          >{{formatAmountCurrency(getCartOrder.totalAmountInclusiveTax,"GBP")}}</v-col>
        </v-row>
      </v-card>
      <v-divider class="divider0"></v-divider>
      <v-row v-if="isCart">
        <v-col class="pt-0 pb-0" align="right">
          <v-checkbox v-model="acceptTos" hide-details>
            <template v-slot:label>
              <div>
                I agree to our
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a target="_blank" href="/tos" @click.stop v-on="on">Terms of Service</a>
                  </template>
                  Opens in new window
                </v-tooltip>
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row v-if="isCart">
        <!-- <v-col class="align-self-center">Checkout with</v-col> -->
        <v-col align="right">
          <v-btn color="#ffc439" dark class="align-self-center" @click="execPlaceOrder()">
            Checkout with
            <img
              class="ml-10 mr-10"
              style="height:20px"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxcHgiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAxMDEgMzIiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaW5ZTWluIG1lZXQiIHhtbG5zPSJodHRwOiYjeDJGOyYjeDJGO3d3dy53My5vcmcmI3gyRjsyMDAwJiN4MkY7c3ZnIj48cGF0aCBmaWxsPSIjMDAzMDg3IiBkPSJNIDEyLjIzNyAyLjggTCA0LjQzNyAyLjggQyAzLjkzNyAyLjggMy40MzcgMy4yIDMuMzM3IDMuNyBMIDAuMjM3IDIzLjcgQyAwLjEzNyAyNC4xIDAuNDM3IDI0LjQgMC44MzcgMjQuNCBMIDQuNTM3IDI0LjQgQyA1LjAzNyAyNC40IDUuNTM3IDI0IDUuNjM3IDIzLjUgTCA2LjQzNyAxOC4xIEMgNi41MzcgMTcuNiA2LjkzNyAxNy4yIDcuNTM3IDE3LjIgTCAxMC4wMzcgMTcuMiBDIDE1LjEzNyAxNy4yIDE4LjEzNyAxNC43IDE4LjkzNyA5LjggQyAxOS4yMzcgNy43IDE4LjkzNyA2IDE3LjkzNyA0LjggQyAxNi44MzcgMy41IDE0LjgzNyAyLjggMTIuMjM3IDIuOCBaIE0gMTMuMTM3IDEwLjEgQyAxMi43MzcgMTIuOSAxMC41MzcgMTIuOSA4LjUzNyAxMi45IEwgNy4zMzcgMTIuOSBMIDguMTM3IDcuNyBDIDguMTM3IDcuNCA4LjQzNyA3LjIgOC43MzcgNy4yIEwgOS4yMzcgNy4yIEMgMTAuNjM3IDcuMiAxMS45MzcgNy4yIDEyLjYzNyA4IEMgMTMuMTM3IDguNCAxMy4zMzcgOS4xIDEzLjEzNyAxMC4xIFoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAzMDg3IiBkPSJNIDM1LjQzNyAxMCBMIDMxLjczNyAxMCBDIDMxLjQzNyAxMCAzMS4xMzcgMTAuMiAzMS4xMzcgMTAuNSBMIDMwLjkzNyAxMS41IEwgMzAuNjM3IDExLjEgQyAyOS44MzcgOS45IDI4LjAzNyA5LjUgMjYuMjM3IDkuNSBDIDIyLjEzNyA5LjUgMTguNjM3IDEyLjYgMTcuOTM3IDE3IEMgMTcuNTM3IDE5LjIgMTguMDM3IDIxLjMgMTkuMzM3IDIyLjcgQyAyMC40MzcgMjQgMjIuMTM3IDI0LjYgMjQuMDM3IDI0LjYgQyAyNy4zMzcgMjQuNiAyOS4yMzcgMjIuNSAyOS4yMzcgMjIuNSBMIDI5LjAzNyAyMy41IEMgMjguOTM3IDIzLjkgMjkuMjM3IDI0LjMgMjkuNjM3IDI0LjMgTCAzMy4wMzcgMjQuMyBDIDMzLjUzNyAyNC4zIDM0LjAzNyAyMy45IDM0LjEzNyAyMy40IEwgMzYuMTM3IDEwLjYgQyAzNi4yMzcgMTAuNCAzNS44MzcgMTAgMzUuNDM3IDEwIFogTSAzMC4zMzcgMTcuMiBDIDI5LjkzNyAxOS4zIDI4LjMzNyAyMC44IDI2LjEzNyAyMC44IEMgMjUuMDM3IDIwLjggMjQuMjM3IDIwLjUgMjMuNjM3IDE5LjggQyAyMy4wMzcgMTkuMSAyMi44MzcgMTguMiAyMy4wMzcgMTcuMiBDIDIzLjMzNyAxNS4xIDI1LjEzNyAxMy42IDI3LjIzNyAxMy42IEMgMjguMzM3IDEzLjYgMjkuMTM3IDE0IDI5LjczNyAxNC42IEMgMzAuMjM3IDE1LjMgMzAuNDM3IDE2LjIgMzAuMzM3IDE3LjIgWiI+PC9wYXRoPjxwYXRoIGZpbGw9IiMwMDMwODciIGQ9Ik0gNTUuMzM3IDEwIEwgNTEuNjM3IDEwIEMgNTEuMjM3IDEwIDUwLjkzNyAxMC4yIDUwLjczNyAxMC41IEwgNDUuNTM3IDE4LjEgTCA0My4zMzcgMTAuOCBDIDQzLjIzNyAxMC4zIDQyLjczNyAxMCA0Mi4zMzcgMTAgTCAzOC42MzcgMTAgQyAzOC4yMzcgMTAgMzcuODM3IDEwLjQgMzguMDM3IDEwLjkgTCA0Mi4xMzcgMjMgTCAzOC4yMzcgMjguNCBDIDM3LjkzNyAyOC44IDM4LjIzNyAyOS40IDM4LjczNyAyOS40IEwgNDIuNDM3IDI5LjQgQyA0Mi44MzcgMjkuNCA0My4xMzcgMjkuMiA0My4zMzcgMjguOSBMIDU1LjgzNyAxMC45IEMgNTYuMTM3IDEwLjYgNTUuODM3IDEwIDU1LjMzNyAxMCBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwOWNkZSIgZD0iTSA2Ny43MzcgMi44IEwgNTkuOTM3IDIuOCBDIDU5LjQzNyAyLjggNTguOTM3IDMuMiA1OC44MzcgMy43IEwgNTUuNzM3IDIzLjYgQyA1NS42MzcgMjQgNTUuOTM3IDI0LjMgNTYuMzM3IDI0LjMgTCA2MC4zMzcgMjQuMyBDIDYwLjczNyAyNC4zIDYxLjAzNyAyNCA2MS4wMzcgMjMuNyBMIDYxLjkzNyAxOCBDIDYyLjAzNyAxNy41IDYyLjQzNyAxNy4xIDYzLjAzNyAxNy4xIEwgNjUuNTM3IDE3LjEgQyA3MC42MzcgMTcuMSA3My42MzcgMTQuNiA3NC40MzcgOS43IEMgNzQuNzM3IDcuNiA3NC40MzcgNS45IDczLjQzNyA0LjcgQyA3Mi4yMzcgMy41IDcwLjMzNyAyLjggNjcuNzM3IDIuOCBaIE0gNjguNjM3IDEwLjEgQyA2OC4yMzcgMTIuOSA2Ni4wMzcgMTIuOSA2NC4wMzcgMTIuOSBMIDYyLjgzNyAxMi45IEwgNjMuNjM3IDcuNyBDIDYzLjYzNyA3LjQgNjMuOTM3IDcuMiA2NC4yMzcgNy4yIEwgNjQuNzM3IDcuMiBDIDY2LjEzNyA3LjIgNjcuNDM3IDcuMiA2OC4xMzcgOCBDIDY4LjYzNyA4LjQgNjguNzM3IDkuMSA2OC42MzcgMTAuMSBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzAwOWNkZSIgZD0iTSA5MC45MzcgMTAgTCA4Ny4yMzcgMTAgQyA4Ni45MzcgMTAgODYuNjM3IDEwLjIgODYuNjM3IDEwLjUgTCA4Ni40MzcgMTEuNSBMIDg2LjEzNyAxMS4xIEMgODUuMzM3IDkuOSA4My41MzcgOS41IDgxLjczNyA5LjUgQyA3Ny42MzcgOS41IDc0LjEzNyAxMi42IDczLjQzNyAxNyBDIDczLjAzNyAxOS4yIDczLjUzNyAyMS4zIDc0LjgzNyAyMi43IEMgNzUuOTM3IDI0IDc3LjYzNyAyNC42IDc5LjUzNyAyNC42IEMgODIuODM3IDI0LjYgODQuNzM3IDIyLjUgODQuNzM3IDIyLjUgTCA4NC41MzcgMjMuNSBDIDg0LjQzNyAyMy45IDg0LjczNyAyNC4zIDg1LjEzNyAyNC4zIEwgODguNTM3IDI0LjMgQyA4OS4wMzcgMjQuMyA4OS41MzcgMjMuOSA4OS42MzcgMjMuNCBMIDkxLjYzNyAxMC42IEMgOTEuNjM3IDEwLjQgOTEuMzM3IDEwIDkwLjkzNyAxMCBaIE0gODUuNzM3IDE3LjIgQyA4NS4zMzcgMTkuMyA4My43MzcgMjAuOCA4MS41MzcgMjAuOCBDIDgwLjQzNyAyMC44IDc5LjYzNyAyMC41IDc5LjAzNyAxOS44IEMgNzguNDM3IDE5LjEgNzguMjM3IDE4LjIgNzguNDM3IDE3LjIgQyA3OC43MzcgMTUuMSA4MC41MzcgMTMuNiA4Mi42MzcgMTMuNiBDIDgzLjczNyAxMy42IDg0LjUzNyAxNCA4NS4xMzcgMTQuNiBDIDg1LjczNyAxNS4zIDg1LjkzNyAxNi4yIDg1LjczNyAxNy4yIFoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDA5Y2RlIiBkPSJNIDk1LjMzNyAzLjMgTCA5Mi4xMzcgMjMuNiBDIDkyLjAzNyAyNCA5Mi4zMzcgMjQuMyA5Mi43MzcgMjQuMyBMIDk1LjkzNyAyNC4zIEMgOTYuNDM3IDI0LjMgOTYuOTM3IDIzLjkgOTcuMDM3IDIzLjQgTCAxMDAuMjM3IDMuNSBDIDEwMC4zMzcgMy4xIDEwMC4wMzcgMi44IDk5LjYzNyAyLjggTCA5Ni4wMzcgMi44IEMgOTUuNjM3IDIuOCA5NS40MzcgMyA5NS4zMzcgMy4zIFoiPjwvcGF0aD48L3N2Zz4="
              alt="paypal"
            />
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="caption" v-if="!isCart">
        <v-col>
          <v-select
            v-model="selectedAudioFormat"
            outlined
            dense
            item-value="value"
            item-text="name"
            :items="ac.AudioFormats"
            label="Select audio format"
            hide-details
          ></v-select>
        </v-col>
        <v-col>
          <v-btn
            outlined
            dense
            @click="downloadOrder2({audioFormat: selectedAudioFormat,orderId:order.id})"
          >
            Download
            <v-icon right>mdi-download</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="caption" v-if="!isCart">
        <v-col>Download will be packed in a zip, make sure you have an unzip app.<br>

          If you have any questions, please contact us
          <router-link :to="{name:'contact'}">here</router-link>

        </v-col>
      </v-row>
      <v-row class="caption" v-if="isCart">
        <v-col
          align="right"
        >After payment your file downloads will be available immediately in a format of your choice starting at 24bit 44100Hz wav.</v-col>
      </v-row>
    </div>
    <div v-if="!isCart && (orders && orders.length > 0)" class="mb-8">
      <v-row class="glass3 mt-4">
        <v-col>Order History</v-col>
      </v-row>
      <v-data-table
        :items="orders"
        :headers="headers"
        class="transparent-bg"
        must-sort
        :sort-by.sync="myOrdersTableState.sortBy"
        :sort-desc.sync="myOrdersTableState.sortDesc"
        :page.sync="myOrdersTableState.currentPage"
        :items-per-page.sync="myOrdersTableState.itemsPerPage"
        :footer-props="{ 'items-per-page-options':myOrdersTableState.itemsPerPageOptions }"
        :mobile-breakpoint="200"
        @click:row="rowClickDetail"
        style="cursor:pointer"
        :hide-default-footer="orders === null || orders.length <= myOrdersTableState.itemsPerPage"
        :value="selectedOrder"
        item-key="id"
        single-select
      >
        <template
          v-slot:item.totalAmountInclusiveTax="{ item }"
        >{{formatAmountCurrency(item.totalAmountInclusiveTax,"GBP")}}</template>
        <template v-slot:item.dateFulfilled="{ item }">{{moment(item.dateFulfilled).format('LLL')}}</template>
        <template v-slot:item.lineItems="{ item }">{{item.lineItems.length}}</template>
        <template v-slot:item.publish="{ item }">
          <v-icon v-if="item.publish" small color="accent">mdi-check</v-icon>
        </template>
      </v-data-table>
    </div>

    <v-overlay v-model="waitOverlay" z-index="1000" :opacity=".9">
      <v-row align="center" justify="center" class="fill-height">
        <v-col align="center" class="accent--text" cols="12">{{waitText}}</v-col>
        <v-col align="center" class="accent--text" cols="12">
          <v-progress-circular
            :value="progressData"
            :size="220"
            :width="8"
            :indeterminate="processingFiles"
            color="accent"
          >{{progressData}}</v-progress-circular>
        </v-col>
      </v-row>
    </v-overlay>
    <v-overlay v-model="redirectOverlay" z-index="1000" :opacity=".9">
      <v-row align="center" justify="center" class="fill-height">
        <!-- <v-col align="center" class="accent--text" cols="12">Redirecting to PayPal</v-col> -->
        <v-col align="center" class="accent--text" cols="12">
          <v-progress-circular :size="220" :width="8" color="accent" indeterminate>
            <div v-if="!pageLoaded && isCart">Loading...</div>
            <div v-if="pageLoaded && isCart">Redirecting to PayPal</div>
            <div v-if="!isCart">Processing Order</div>
          </v-progress-circular>
        </v-col>
      </v-row>
    </v-overlay>
  </v-container>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import defaultMixin from "@/mixins/defaultMixin";
import { createNamespacedHelpers } from "vuex";
import axios from "axios";

const {
  mapState: mapStateReleases,
  mapActions: mapActionsReleases
} = createNamespacedHelpers("releases");

export default {
  name: "Order",
  mixins: [defaultMixin],
  data: () => ({
    headers: [
      { text: "Order date", value: "dateFulfilled" },
      { text: "Items", value: "lineItems.length" },
      { text: "Total Amount", value: "totalAmountInclusiveTax", align: "right" }
    ],
    search: "",
    dialog: false,
    myTableState: {},
    myOrdersTableState: {},
    redirectOverlay: false,
    selectedOrder: [],
    selectedAudioFormat: "",
    waitOverlay: false,
    progressData: "",
    processingFiles: false,
    waitText: "Preparing files for Download, please wait",
    acceptTos: false,
    bannerText:
      "Thank you for shopping with us. Your support is much appreciated",
    pageLoaded: false
  }),
  async created() {
    this.redirectOverlay = true;
    this.myTableState = this.getTableState("releaseTable");
    if (!this.myTableState.sortBy) {
      this.myTableState.sortBy = "dateRelease";
      this.myTableState.sortDesc = true;
    }
    this.myOrdersTableState = this.getTableState("ordersTable");
    if (!this.myOrdersTableState.sortBy) {
      this.myOrdersTableState.sortBy = "dateFulfilled";
      this.myOrdersTableState.sortDesc = true;
    }
    await this.fetchPubReleases();

    if (!this.isCart) {
      this.redirectOverlay = true;
      const orderLoaded = await this.fetchOrder({
        orderId: this.$route.params.orderid
      });

      if (orderLoaded) {
        if (this.order && this.order.audioFormat) {
          this.selectedAudioFormat = this.order.audioFormat;
        }
      }

      if (this.selectedAudioFormat === "") {
        this.selectedAudioFormat = this.ac.AudioFormats[0].value;
      }

      const result = await this.fetchOrders();
      if (!result) {
        this.redirectOverlay = false;
        this.$router.push({ path: "/notfound/" });
      }
      this.redirectOverlay = false;
      if (this.$route.params.orderid) {
        this.selectedOrder = [
          this.orders.find(o => o.id === this.$route.params.orderid)
        ];
      }
    } else {
      await this.fetchCart();
    }
    this.pageLoaded = true;
    this.redirectOverlay = false;
  },
  computed: {
    ...mapStateReleases(["pubreleases"]),
    getCartOrder: {
      get: function() {
        if (!this.isCart) {
          return this.order;
        } else {
          return this.cart;
        }
      }
    },
    isCart: {
      get: function() {
        return this.$route.name === "cart";
      }
    },
    isNewPurchase: {
      get: function() {
        return this.newPurchase && !this.isCart;
      }
    }
  },
  methods: {
    ...mapActionsReleases(["fetchPubReleases"]),
    rowClickDetail(e) {
      console.log("rowClickDetail " + e.id);
      if (!this.order || e.id !== this.order.id) {
        this.$router.push({ name: "order", params: { orderid: e.id } });
      }
    },
    execPlaceOrder() {
      if (this.acceptTos) {
        this.redirectOverlay = true;
        this.placeOrder();
      } else {
        this.setMessage({
          message: "You must accept the terms of service",
          dialog: true,
          type: "warning",
          timeout: 1500
        });
      }
    },
    getReleaseByProductId(productId) {
      console.log("release by track id");
      const result = this.pubreleases.find(release =>
        release.tracks.find(track => track.id === productId)
      );
      return result;
    },
    getTrack(productId) {
      const release = this.getReleaseByProductId(productId);
      const result = release.tracks.find(track => track.id === productId);
      return result;
    },
    getFileUrl(release) {
      if (release.filesImageArtWork) {
        let fileEntity = release.filesImageArtWork[0];
        if (fileEntity) {
          return (
            this.ac.apiBaseURL +
            "res/" +
            "releases" +
            "/" +
            release.id +
            "/" +
            fileEntity.id +
            fileEntity.ext
          );
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    getDayStamp() {
      return new Date()
        .toLocaleString("sv-SE", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        })
        .replace(/-/g, "");
    },
    async downloadOrder2(args) {
      const url = "shop";
      const postdata = {
        apiCommand: "DOWNLOAD_ORDER",
        audioFormat: args.audioFormat,
        orderId: args.orderId
      };

      this.waitOverlay = true;
      this.processingFiles = true;
      this.waitText = "Preparing your files...";
      this.progressData = 0;
      const response = await axios.post(url, postdata, {
        responseType: "blob",
        onDownloadProgress: function(progressEvent) {
          const totalLength = progressEvent.lengthComputable
            ? progressEvent.total
            : progressEvent.target.getResponseHeader(
                "x-decompressed-content-length"
              )
            ? progressEvent.target.getResponseHeader(
                "x-decompressed-content-length"
              )
            : progressEvent.target.getResponseHeader("content-length");

          if (totalLength !== null) {
            this.progressData = Math.round(
              (progressEvent.loaded * 100) / totalLength
            );
            if (this.progressData > 0) {
              this.processingFiles = false;
              this.waitText = "Downloading ...";
            }
            //console.log("progressEvent.loaded " + track.name + " : " + progressData + " " +  progressEvent.loaded);
          }
        }.bind(this)
      });

      this.progressData = 100;
      const url2 = window.URL.createObjectURL(new Blob([response.data]));

      this.bannerText = "You have sucessfully downloaded your files.";

      const link = document.createElement("a");
      link.href = url2;
      link.setAttribute(
        "download",
        this.getDayStamp() +
          "_" +
          this.order.id +
          "_" +
          this.selectedAudioFormat +
          ".zip"
      );
      document.body.appendChild(link);
      link.click();

      this.waitOverlay = false;
    }
  }
};
</script>